import { number, object, string } from "yup";

export default object().shape({
  status: string().required("Required"),
  portfolio: object()
    .shape({
      id: number().required("Required"),
    })
    .required("Required"),
  name: string().required("Required"),
  address: string().required("Required"),
  city: string().required("Required"),
  zip: string().required("Required"),
  country: object()
    .shape({
      id: number().required("Required"),
      name: string().required("Required"),
    })
    .required("Required"),
  pointPerson: object().shape({
    id: number().required("Required"),
  }),
});
